export const COLORS = {
  white: '#FFFFFF',
  black: '#000000',
  gray: '#686868',
  'gray-dark': '#555555',
  'gray-dark-2': '#3B3B3B',
  'gray-light': '#DCDCDC',
  orange: '#C26140',
  accentTextColor: '#BD4A2C',
  yellow: '#F3D079',
  blue: '#253A5A',
  red: '#d32f2f',
  'blue-light': '#334C71',
  'blue-light-2': '#2C5AA0',
  'blue-dark': '#0B1935',
  'beige-silver': '#D1C9B9',
  'beige-light': '#EEDDB3',
  'beige-cream': '#F8F2E4',
  'beige-dove': '#ECE9DF',
  'beige-parch': '#F3F1E9',
  'beige-404': '#F9F7F1',
  'beige-dark': '#827960',

  'additional/50': '#FFFFFF',

  'secondary/50': '#FBF1EE',
  'secondary/100': '#F3D4CC',
  'secondary/400': '#DB7C64',
  'secondary/500': '#D25D3E',
  'secondary/700': '#9A3D24',
  'secondary/800': '#772F1C',

  'primary/50': '#F1F4FC',
  'primary/200': '#C5D1E9',
  'primary/300': '#A8BADC',
  'primary/500': '#647DAF',
  'primary/600': '#4F689A',
  'primary/700': '#40557D',
  'primary/800': '#394B6F',
  'primary/900': '#232E45',
  'primary/910': '#1E2939',
  'primary/950': '#151B28',

  'green/500': '#A09B67',

  'neutral/N90': '#4D4D4D',
  'neutral/50': '#FAFAFA',
  'neutral/100': '#F5F5F5',
  'neutral/200': '#EBEBEB',
  'neutral/300': '#D4D4D4',
  'neutral/400': '#8095be',
  'neutral/500': '#737373',
  'neutral/600': '#525252',
  'neutral/700': '#404040',
  'neutral/800': '#262626',
  'neutral/900': '#171717',
  'neutral/950': '#0A0A0A',

  'brown/50': '#F8F4F2',
  'brown/100': '#E8DCD6',
  'brown/300': '#CAAD9F',
  'brown/400': '#BB9583',
  'brown/600': '#966853',
  'brown/700': '#7A5544',

  'emerald/100': '#E5F4D9',
  'emerald/600': '#5E860D',
  'emerald/700': '#047857',
} as const;
